import AssessmentService from './assessment-service';
import CourseModuleService from './course-module-service';
import CustomizationService from './customization-service';
import EnrollmentService from './enrollment-service';
import InitializationService from './initialization-service';
import ModuleService from './module-service';
import ModulesCollectionService from './modules-collection-service';
import PageService from './page-service';
import PollService from './poll-service';
import ProgressService from './progress-service';
import SiteService from './site-service';
import SurveyService from './survey-service';
import ResourceService from './resource-service';

export default {
  AssessmentService,
  CourseModuleService,
  CustomizationService,
  EnrollmentService,
  InitializationService,
  ModuleService,
  ModulesCollectionService,
  PageService,
  PollService,
  ProgressService,
  SiteService,
  SurveyService,
  ResourceService,
};
